import { useMemo } from 'react';
import { Text } from '@antimatterhq/ui/components/typography';
import Spacer from '@antimatterhq/ui/components/spacer';
import DataSourceGettingStarted from './getting-started';
import DataSourceSilverPreTransform from './pre-silver';
import DataSourceBronze from './bronze';
import DataSource from './source';
import DataSourceSilver from './silver';
import DataSourceGold from './gold';
import DataSourceReview from './review';
import { STEPS, useConfigDataSource } from '@/contexts/ConfigDataSourceContext';
import { DatasourceSteps } from '@/components/steps/DatasourceSteps';

export default function ConfigureDataSource() {
  const { currentStep } = useConfigDataSource();

  const { title, titleBelow } = useMemo(
    () => STEPS.find(({ id }) => id === currentStep)!,
    [currentStep],
  );

  return (
    <div className="px-4" data-testid={`configure-datasource-${currentStep}`}>
      <div className="flex items-center justify-between gap-4">
        <div>
          <Text size="2xl" bold data-testid="configure-datasource-title">
            {title}
          </Text>
        </div>
        <div className="max-w-[850px]">
          <DatasourceSteps />
        </div>
      </div>
      {titleBelow && (
        <div>
          <Text
            size="2xl"
            bold
            style={{ lineHeight: '0.5' }}
            data-testid="configure-datasource-subtitle"
          >
            {titleBelow}
          </Text>
        </div>
      )}
      <div data-testid="configure-datasource-content">
        <Spacer size="lg" />
        {currentStep === 'source' && <DataSource />}
        {currentStep === 'getting-started' && <DataSourceGettingStarted />}
        {currentStep === 'bronze' && <DataSourceBronze />}
        {currentStep === 'silver-pre-transform' && (
          <DataSourceSilverPreTransform />
        )}
        {currentStep === 'silver' && <DataSourceSilver />}
        {currentStep === 'gold' && <DataSourceGold />}
        {currentStep === 'review' && <DataSourceReview />}
      </div>
    </div>
  );
}
